export default __webpack_public_path__ + "static/media/weight-machine.597ee57c.svg";